import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Typography, Rating } from "@mui/material";
import { get_all_testimonials } from '../../services/testimonialService.js'




export default function TestimonialSlider({ restaurant }) {
  const themeColors = {
    accent: restaurant?.theme_config?.accent_color || '#FF6B35',
    primary: restaurant?.theme_config?.primary_color || '#D4AF37',
    secondary: restaurant?.theme_config?.secondary_color || '#8B4513',
  };

  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    try {
      async function getTestimonials() {
        const response = await get_all_testimonials();
        setTestimonials(response)
      }
      getTestimonials()
    }
    catch (error) {
      console.error("Error on Getting Testimonials")
    }
  }, [])

  console.log("Testimonials => ", testimonials)
  return (

    <>
      {testimonials.length > 0 && (
        <>

          <Box sx={{ paddingTop: { xs: 4, md: 6 }, margin: '0 auto', marginBottom: '30px !important', width: { md: '90%' }, textAlign: 'center' }}>
            <Typography variant="h6"
              sx={{
                fontSize: { md: '21px !important' },
                fontWeight: '700',
                background: `linear-gradient(135deg, ${themeColors?.primary}, ${themeColors?.secondary})`,
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent',
                // color: '#351113'
              }}>What Our Customers Say</Typography>
            <Typography variant="h6"
              sx={{
                // fontSize: { md: '13px !important' },
                // color: '#0A0A0A'
                color: "text.secondary"
              }}
            >Real stories from food lovers who've enjoyed our hospitality</Typography>
          </Box>

          <Box
            sx={{
              height: { xs: '30vh', sm: '30vh', md: "40vh" },
              backgroundColor: "#351113",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              mb: 2,
              // paddingBottom:6
              //  flexDirection: "column",
            }}
          >
            <Swiper
              modules={[Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop={true}
              style={{
                width: { xs: '40%', sm: '50%', md: "80%" }, height: { xs: '40%', sm: '50%', md: "100%" },
              }}
            >
              {testimonials.map((t, index) => (
                <SwiperSlide key={index}>
                  <Box sx={{
                    height: { xs: '100%', sm: '50%', md: "100%" },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    px: 2, // padding for small screens
                  }}>
                    <Typography
                      sx={{ fontSize: { xs: '15px !important', sm: '15px !important', md: "20px !important " }, color: "#FFCF03", mb: 2 }}
                    >
                      "{t.title}"
                    </Typography>

                    <Rating
                      name={`testimonial-rating-${index}`}
                      defaultValue={t.stars}
                      precision={0.5}
                      readOnly
                      sx={{
                        mb: 2,
                        "& .MuiSvgIcon-root": { fontSize: { xs: '15px !important', sm: '15px !important', md: "25px !important" } },
                        "& .MuiRating-iconEmpty": {
                          color: "transparent",
                          WebkitTextStroke: "2px #FFCF03",
                        },
                        "& .MuiRating-iconFilled": {
                          color: "#FFCF03",
                          WebkitTextStroke: "2px #FFCF03",
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        margin: "0 auto",
                        width: { xs: "90%", md: "50%" },
                        fontSize: { xs: '12px !important', sm: '12px !important', md: "16px !important " },
                        color: "#FFCF03",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {t.description}

                    </Typography>
                    <Typography
                      sx={{
                        margin: "0 auto",
                        width: { xs: "90%", md: "50%" },
                        fontSize: { xs: '12px !important', sm: '12px !important', md: "16px !important " },
                        color: "#FFCF03",
                      }}
                    >
                      - {t.customer_name}

                    </Typography>
                  </Box>

                  <Box
                    className="swiper-pagination"
                    sx={{
                      position: "relative !important",
                      bottom: "0 !important",
                      mt: 5,
                      display: "flex !important",
                      justifyContent: "center",
                      alignItems: "center",
                      "& .swiper-pagination-bullet": {
                        backgroundColor: "#FFCF03",
                        opacity: 0.5,
                        mx: "3px",
                      },
                      "& .swiper-pagination-bullet-active": {
                        opacity: 1,
                      },
                    }}

                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </>

      )
      }
    </>

  );
}